<template>
    <div class="main">
        <!-- Title of page -->
        <div class="page-title-container">
            {{text['services'].title}}
        </div>

        <!-- Links to sections -->
        <div class="main-link-container flex-wrap">
            <div class="main-link-element" v-for="(x, i) in Object.keys(text['services'].mainLinks)" :key="i">
                <div class="main-link-title">
                    {{ x }}
                </div>
                <div class="main-link-image-container">
                    <div class="inbetween-img-container">
                        <img class="main-link-image" :class="[text['services'].mainLinks[x].imageAlign]" :src="text['services'].mainLinks[x].image">
                    </div>
                </div>
                <button class="main-link-btn" @click="scrollMeTo(text['services'].mainLinks[x].link)">
                    {{ text['services'].mainLinks[x].text }}
                </button>
            </div>
        </div>

        <!-- <hr class="line-separator" /> -->

        <!-- Ambitos de actuacion -->
        <div class="section-container" id="action-areas-container">
            <div class="section-title-container">
                <div class="section-title-background">
                    <span class="section-title-title">
                        {{ text['services'].areasOfActionInfo.title }}
                    </span>
                </div>
                <div class="section-title-text" v-if="text['services'].areasOfActionInfo.description.length != 0">
                    <span class="section-title-description">
                        {{ text['services'].areasOfActionInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['services'].areasOfActionInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['services'].areasOfActionInfo.methodsOfTreatement[k]" :key="j">
                            <div :class="[lines.includes('[U]') ? 'text-decoration-underline'/*'fw-bold'*/ : '']">{{ lines.includes("[U]") ? lines.substr(3) : lines}}</div>
                            <ul class="section-list-container" v-if="Object.keys(text['services'].lists).includes(k+j)">
                                <li v-for="element in text['services'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['services'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['services'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" />

        <!-- Fisioterapia info container -->
        <div class="section-container" id="fisio-container">
            <div class="section-title-container">
                <div class="section-title-background section-title-background-right">
                    <span class="section-title-title">
                        {{ text['services'].fisioInfo.title }}
                    </span>
                </div>
                <div class="section-title-text section-title-text-right">
                    <span class="section-title-description section-title-description-right">
                        {{ text['services'].fisioInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['services'].fisioInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['services'].fisioInfo.methodsOfTreatement[k]" :key="j">
                            {{ lines }}<br/>
                            <ul class="section-list-container" v-if="Object.keys(text['services'].lists).includes(k+j)">
                                <li v-for="element in text['services'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['services'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['services'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" />

        <!-- Osteopatia info container -->
        <div class="section-container" id="osteo-container">
            <div class="section-title-container">
                <div class="section-title-background">
                    <span class="section-title-title">
                        {{ text['services'].osteoInfo.title }}
                    </span>
                </div>
                <div class="section-title-text">
                    <span class="section-title-description">
                        {{ text['services'].osteoInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['services'].osteoInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(text, j) in text['services'].osteoInfo.methodsOfTreatement[k]" :key="j">
                            {{ text }}<br/>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['services'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['services'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" />

        <!-- INDIBA info container -->
        <div class="section-container" id="indiba-container">
            <div class="section-title-container">
                <div class="section-title-background section-title-background-right">
                    <span class="section-title-title">
                        {{ text['services'].indibaInfo.title }}
                    </span>
                </div>
                <div class="section-title-text section-title-text-right">
                    <span class="section-title-description section-title-description-right">
                        {{ text['services'].indibaInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['services'].indibaInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['services'].indibaInfo.methodsOfTreatement[k]" :key="j">
                            {{ lines }}<br/>
                            <ul class="section-list-container" v-if="Object.keys(text['services'].lists).includes(k+j)">
                                <li v-for="element in text['services'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['services'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['services'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" />

        <!-- PNIE info container -->
        <div class="section-container" id="pnie-container">
            <div class="section-title-container">
                <div class="section-title-background">
                    <span class="section-title-title section-title-title-small">
                        {{ text['services'].pnieInfo.title }}
                    </span>
                </div>
                <div class="section-title-text">
                    <span class="section-title-description section-title-description-right">
                        {{ text['services'].pnieInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['services'].pnieInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['services'].pnieInfo.methodsOfTreatement[k]" :key="j">
                            <div :class="[lines.includes('[U]') ? 'text-decoration-underline'/*'fw-bold'*/ : '']">{{ lines.includes("[U]") ? lines.substr(3) : lines}}</div>
                            <ul class="section-list-container" v-if="Object.keys(text['services'].lists).includes(k+j)">
                                <li v-for="element in text['services'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['services'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['services'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5"></div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "Services",
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(["idSelected", "text"]),
    },
    methods: {
        ...mapMutations(["setIdSelected"]),
        scrollMeTo(refName) {
            let element = document.querySelector(refName);
            let top = element.offsetTop - 150;
            window.scrollTo(0, top);
        },
    },
    mounted() {
        if(this.idSelected.length > 0) {
            this.scrollMeTo(this.idSelected);
            this.setIdSelected("");
        } else {
            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 1);
        }
    },
}
</script>

<style scoped>
.main {
    overflow: hidden;
}

.pictures-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
    margin: 2rem 0;
}

.picture-container {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    box-shadow: 0 0 15px 0 var(--blue-color);
}

.picture-container > img {
    width: 100%;
    position: absolute;
}
</style>